/** LPR data source identifiers (matches backend integration names) */
export enum ViLPRProvider {
  AXON_VI = 'axon_vi',
  // WWA is not a real provider, it's derived from AXON_VI
  WORKS_WITH_AXON = 'works_with_axon',
  VIGILANT = 'vigilant_ps',
  FLOCK = 'flock_ps',
  FLOCK_V3 = 'flock_ps_v3',
  FUSUS = 'fusus_ps',
}

/** Translation keys for user-facing provider names in the source selection dropdown */
export enum ViLPRProviderDisplayNameTranslationKey {
  AXON_VI = 'vehicleIntelligence.alprSearch.sourceSelect.allAxon',
  WORKS_WITH_AXON = 'vehicleIntelligence.alprSearch.sourceSelect.worksWithAxon',
  VIGILANT = 'vehicleIntelligence.alprSearch.sourceSelect.vigilant',
  FLOCK = 'vehicleIntelligence.alprSearch.sourceSelect.flock',
  FLOCK_V3 = 'vehicleIntelligence.alprSearch.sourceSelect.flockV3',
  FUSUS = 'vehicleIntelligence.alprSearch.sourceSelect.fusus',
}
